// @flow

export const compareNatural = (value: string, other: string) => {
  return (value || '').localeCompare(other || '', undefined, {
    numeric: true,
    sensitivity: 'base',
  });
};

export default compareNatural;
